import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector   : 'wor-customer-statement-settings',
  template: require('./customer-statement-settings.component.html')
})
export class CustomerStatementSettingsComponent {
  settings: any = {
    as_at       : '*',
    begin_date  : '*',
    end_date    : '*',
    include_paid: true,
    statement   : false
  };

  constructor (
    public activeModal: NgbActiveModal
  ) {}

  confirm (): void {
    this.activeModal.close(this.settings);
  }
}
